export const ratesConstants = {
  bookImg: 'https://www.fr8.in/_next/image?url=%2Fimages%2Fbook-truck.webp&w=96&q=75',
  loadImg: 'https://www.fr8.in/_next/image?url=%2Fimages%2Fbook-load.webp&w=96&q=75',
  loadsAppImg: 'https://www.fr8.in/_next/image?url=%2Fimages%2Fload-mobile.png&w=640&q=100',
  bookIndentUrl: 'https://book.fr8.in/create-indent',
  loadsLoginUrl: "https://loads.fr8.in",
  gpLoadsUrl: "https://play.google.com/store/apps/details?id=in.fr8.partner",
  utmOrganic: "?utm_source=google&utm_medium=organic",
  truckRatesPath: '/truck-rates'

}